import { CHANNEL_SERVER } from "./constants";
import request from "./request";

interface BaseRes {
    code: string;
    msg: string;
    data: any;
}

interface AddFriendProps {
    email?: string;
    receiverId?: string;
    senderNickname: string;
    senderLogo: string;
    relationType?: number; // 0-普通好友 1-情侣 2-闺蜜 3-兄弟
    blockMsgBox?: boolean; // 前端用于是否拦截错误弹窗，默认值为"false"
}

// 根据账号添加好友
export const AddFriend = async (data: AddFriendProps): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/add",
        method: "post",
        data: data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

interface ApplicationItem {
    id: number;
    senderId: string;
    receiverId: string;
    status: number; // 0-待确认 1-已确认 2-已拒绝 3-已过期
    sendTime: string;
    handleTime: string;
    notified: number;
    senderNickname: string;
    receiverNickname: string;
    senderLogo: string;
    receiverLogo: string;
}
interface ApplicationResProps {
    code: string;
    msg: string;
    data: {
        receivedRequests: ApplicationItem[];
        sentRequests: ApplicationItem[];
    };
}

// 主动获取好友申请与发出申请列表
export const getApplicationList = async (): Promise<ApplicationResProps> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/requests",
        method: "get",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

interface IntimateProps {
    userId: string;
    friendId?: string;
    relationType: number; // 0-普通好友 1-情侣 2-闺蜜 3-兄弟
    intimateRequestId?: number;
    flag?: 0 | 1; // 0-拒绝 1-同意
}

// 变更亲密关系
export const changeIntimate = async (params: IntimateProps): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/change",
        method: "post",
        data: params,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 确认变更亲密关系
export const handleIntimate = async (params: IntimateProps): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/intimate",
        method: "post",
        data: params,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface ApplicationActionProps {
    userNickname: string;
    userLogo: string;
    friendId: string;
    friendNickname: string;
    friendLogo: string;
    relationType?: number; // 0-普通好友 1-情侣 2-闺蜜 3-兄弟
    flag: 0 | 1; // 0-拒绝 1-同意
    intimateRequestId?: number;
}

// 处理好友申请
export const handleApplication = async (params: ApplicationActionProps): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/handle",
        method: "post",
        data: params,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 设置申请消息已读
export const readApplicationMsg = async (): Promise<ApplicationResProps> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/read",
        method: "post",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 撤回好友申请
export const revokeApplication = async (receiverId: string): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/revoke",
        method: "post",
        data: {
            receiverId,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};
interface DissolutionProps {
    relationType: number; // 0-普通好友 1-情侣 2-闺蜜 3-兄弟
    friendId: string;
    userNickname?: string; // 解除亲密关系者名称
    friendNickname?: string; // 被解除亲密关系者名称
    release: number; // 0-解除亲密关系， 1-删除好友
}
// 解除亲密关系
export const dissolutionFriend = async (params: DissolutionProps): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/delete",
        method: "post",
        data: params,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

interface EmojiProps {
    type: string;
    senderId: string;
    receiverId: string;
    messageId: string;
    emojiCode: string;
}

// 点击、取消反应表情
export const reactionEmoji = async (params: EmojiProps): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/conversation/emoji",
        method: "post",
        data: params,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

interface ReporterProps {
    reportedNickName: string;
    reportedUserId: string;
    reason: number;
    description: string;
    evidenceUrls: string;
}

// 举报用户
export const reportUser = async (params: ReporterProps): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/report/report",
        method: "post",
        data: params,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 亲密关系申请关系好友私信消息ID
// export const setMsgId = async (params: { msgId: string; id: string }): Promise<BaseRes> => {
//     return request({
//         // cspell:disable-next-line
//         url: CHANNEL_SERVER + "/gcms/v1/friend/setmsgid",
//         method: "post",
//         data: params,
//         headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//     });
// };

// 屏蔽好友
export const blockFriend = async (blockedId: string): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/friend/block",
        method: "post",
        data: {
            blockedId,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 取消屏蔽
export const cancelBlock = async (blockedId: string): Promise<BaseRes> => {
    return request({
        // cspell:disable-next-line
        url: CHANNEL_SERVER + "/gcms/v1/friend/cancelblock",
        method: "post",
        data: {
            blockedId,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 获取黑名单列表
export const getBlockList = async (): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/block/list",
        method: "get",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 私聊对话框内的亲密关系消息已读
export const setIntimateChatRead = async (friendId: string): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/intimate/chat/read",
        method: "post",
        data: {
            friendId,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 设置全部亲密关系邀请已读
export const setIntimateRead = async (): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/intimate/read",
        method: "post",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export const revokeIntimate = async (id: number): Promise<BaseRes> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/intimate/revoke",
        method: "post",
        data: {
            id,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};
